/**
 * The backend pages these lists (20 by default, 100 at most) and answers a
 * bare array, while the screens show them whole: a club with many teams or
 * opponents lost the end of the alphabet without a word (VOL-324).
 */
export const FULL_LIST_LIMIT = 100;
/** 2 000 items: far beyond a club, and no endless loop if the backend ignores `page`. */
const MAX_PAGES = 20;

export function listQuery(season?: string, page = 1): string {
  const params = new URLSearchParams({ limit: String(FULL_LIST_LIMIT) });
  if (page > 1) params.set('page', String(page));
  if (season) params.set('season', season);
  return params.toString();
}

/** Every page of a list, until one comes back short. */
export async function fetchAllPages<T>(fetchPage: (page: number) => Promise<T[]>): Promise<T[]> {
  const items: T[] = [];
  for (let page = 1; page <= MAX_PAGES; page += 1) {
    const batch = await fetchPage(page);
    items.push(...batch);
    if (batch.length < FULL_LIST_LIMIT) break;
  }
  return items;
}
